import styled from 'styled-components';

export const NumericDate = styled.span`
  letter-spacing: 0.7px;
`;
